import { useState, useEffect } from "react";
import Drawer from "react-modern-drawer";
import { useGetProductQuery, useGetProductByHandleQuery } from "../../store/services/productApi.js";
import "react-modern-drawer/dist/index.css";
import "./CapsuleDrawer.css";

const CapsuleDrawer = ({ isOpen, toggleDrawer, product, variant }) => {
  const [showMore, setShowMore] = useState(false);
  const [buttonText, setButtonText] = useState("Read More");

  const productId = product?.productPlatformId?.replace("gid://shopify/Product/", "");

  const {
    data: capsuleData,
    error: capsuleError,
    isLoading: capsuleLoading,
  } = useGetProductQuery(productId);

  const {
    data: capsuleDescData,
    error: capsuleDescError,
    isLoading: capsuleDescLoading,
  } = useGetProductByHandleQuery(product?.productHandle);

  const handleReadMore = () => {
    setShowMore((prevShowMore) => !prevShowMore);
  };

  useEffect(() => {
    const moreText = document.querySelector(`#${product.productHandle} #more`);
    const dots = document.querySelector(`#${product.productHandle} #dots`);

    if (moreText && dots) {
      if (showMore) {
        moreText.style.display = "block";
        dots.style.display = "none";
        setButtonText("Read Less");
      } else {
        moreText.style.display = "none";
        dots.style.display = "inline";
        setButtonText("Read More");
      }
    }
  }, [showMore, product.productHandle]);

  useEffect(() => {
    const button = document.getElementById(`myBtn-${product.productHandle}`);
    if (button) {
      button.addEventListener("click", handleReadMore);
    }

    return () => {
      if (button) {
        button.removeEventListener("click", handleReadMore);
      }
    };
  }, [product.productHandle]);

  if (capsuleError || capsuleDescError)
    // return <p>Error loading product data. Please try again later.</p>;
    return null;

  const productDescription = capsuleDescData?.description || "";

  return (
    <Drawer open={isOpen} onClose={toggleDrawer} direction="right" className="capsule-drawer">
      <button className="close-button" onClick={toggleDrawer}>
        X
      </button>
      <div className="capsule-drawer-details">
        {capsuleData && (
          <>
            <img
              className="capsule-drawer-image"
              src={capsuleData.images?.edges[0].node.url}
              alt={capsuleData.images?.edges[0].node.altText || "Product image"}
            />
            <h2 className="capsule-drawer-product-title">
              {product.productTitle} - {variant.productVariantTitle}
            </h2>

            <div
              id={product.productHandle}
              className="capsule-drawer-product-description"
              dangerouslySetInnerHTML={{ __html: productDescription }}
            />

            {productDescription && productDescription.includes("myBtn") && (
              <button
                id={`myBtn-${product.productHandle}`}
                onClick={handleReadMore}
                className="myBtn-toggle">
                {buttonText}
              </button>
            )}
          </>
        )}
      </div>
    </Drawer>
  );
};

export default CapsuleDrawer;
